import getConfig from "next/config";

import { i18n } from "@lib/i18n";

import api from "@api";
import { toast } from "@lib/reactToastify";
import { getStaticAssetURL } from "./getStaticAssetURL";
import { getCarImagePath } from "@shared/v2/lib/getCarImagePath";

const { publicRuntimeConfig } = getConfig();
const { COUNTRY } = publicRuntimeConfig;

export const sendConfiguration = async (
  email,
  name,
  preconfiguration,
  configurationUrl,
  brandCode
) => {
  const emailSpecification = {
    specification: {
      country: COUNTRY,
      brand: brandCode,
      language: i18n.language,
    },
    configuration: {
      configurationUrl,
      email,
      name,
      model: {
        preconfigurationId: preconfiguration.id,
        label: preconfiguration.label,
        image: getStaticAssetURL(getCarImagePath(preconfiguration.id)),
      },
    },
  };

  try {
    await api.sendConfigurationByEmail(emailSpecification);

    return true;
  } catch (error) {
    toast.error(i18n.t("basket.shareConfigurationModal.error"));
  }

  return false;
};
